export interface Backup {
    id: string;
    name: string;
    path: string;
    userId: string;
    created?: string;
    updated?: string;
}
